'use strict';

const permissions = require('./permissions');

module.exports = {
  [permissions.ADMIN_GROUPS_CREATE]: true,
  [permissions.ADMIN_GROUPS_READ]: true,
  [permissions.ADMIN_GROUPS_UPDATE]: true,
  [permissions.ADMIN_GROUPS_DELETE]: true,

  [permissions.ADMIN_USER_GROUPS_READ]: true,
  [permissions.ADMIN_USER_GROUPS_DELETE]: true,
  [permissions.ADMIN_USER_GROUPS_UPDATE]: true,

  [permissions.ADMIN_IMAGES_UPLOAD]: true,

  [permissions.ADMIN_FEED_MODERATION]: true,
};
